import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { SET_SEARCH_RESULTS, CLEAR_SEARCH_RESULTS } from './constants';

const initialState = {
  searchResults: [],
};

export const searchResultReducer = createReducer(initialState, {
  [SET_SEARCH_RESULTS]: (state, action) => {
    return {
      searchResults: action.payload,
    };
  },
  [CLEAR_SEARCH_RESULTS]: (state, action) => {
    return {
      searchResults: [],
    };
  },
});
